<template>
  <div class="vm-vote" :class="[browser_size]">
      <div v-if="status_pre == 'edit'" class="mb16 flex-box flex-direction-row-reverse">
        <span class="black-3 gl-hover-text ml16 fs14" @click="del">{{$t('c.Vote.text1')}}</span>
        <span v-if="!vote_pre.post_id" class="purple gl-hover-text-purple fs14" @click="edit">{{$t('c.Vote.text2')}}</span>
      </div>
      <div class="mq fs-16-14 fwb">{{vote_pre.title}}（{{vote_pre.chosen_type == 1 ? '单' : '多'}}选）</div>
      <div class="flex-box black-3 mt16 fs12">
        <span class="mr8">{{vote_pre.result_total || 0}}{{$t('c.Vote.text3')}}</span>
        <span v-if="vote_pre.deadline != -1 && status_pre != 'finished'">{{$time_to_future(vote_pre.deadline * 1000)}}{{$t('c.Vote.text4')}}</span>
      </div>
      <section v-if="status_pre == 'edit'" class="checklist">
        <div class="pt16 pb16" v-for="(item,i) in vote_pre.options" :key="i">
            <checkbox :disabled="is_disable" class="gl-hover-text pointer baseline">{{item.name}}</checkbox>
            <div class="img-pre-box mt8" v-if="item.pic">
              <pic height="50" type="2" :src="item.pic"></pic>
            </div>
        </div>
      </section>
      <template v-if="status_pre == 'before'">
        <div class="pt16 pb16" v-for="(item,i) in vote_pre.options" :key="i">
            <radio v-if="vote_pre.chosen_type == 1" class="gl-hover-text pointer baseline" :value="item.value" v-model="my_vote_pre">{{item.name}}</radio>
            <checkbox v-if="vote_pre.chosen_type == 2" class="gl-hover-text pointer baseline" name="my_vote_pre[]" :value="item.value" v-model="my_vote_pre">{{item.name}}</checkbox>
            <div class="img-pre-box mt8" v-if="item.pic">
              <pic class="pointer" height="50" type="2" :src="item.pic" @click.native="open_img(item.pic)"></pic>
            </div>
        </div>
      </template>
      <section v-if="status_pre == 'after' || status_pre == 'finished'" class="mb16">
        <div v-for="(item,i) in vote_pre.options" :key="i" class="result mt16">
          <div class="flex-box flex-justify-content-space-between">
            <span class="fs14 black-8">{{item.name}}<span v-if="$is_array(my_vote_pre) ? my_vote_pre.indexOf(item.value) != -1 : my_vote_pre == item.value" class="purple">{{$t('c.Vote.text5')}}</span></span>
            <span class="black-3 fs14" v-if="vote_pre.result[item.value]">{{vote_pre.result[item.value].count}}（{{vote_pre.result[item.value].percent}}）</span>
          </div>
          <div class="img-pre-box mt8" v-if="item.pic">
            <pic class="pointer" height="50" type="2" :src="item.pic" @click.native="open_img(item.pic)"></pic>
          </div>
          <div class="progress-box mt12">
            <div class="progress-bar" :class="{on: $is_array(my_vote_pre) ? my_vote_pre.indexOf(item.value) != -1 : my_vote_pre == item.value}" :style="{width: vote_pre.result[item.value] ? vote_pre.result[item.value].percent : ''}"></div>
          </div>
        </div>
      </section>
      <btn class="submit look1 fs16" :class="[is_disable ? 'disable' : '', status_pre == 'before' &&  has_my_vote_pre ? 'look3' : '', status_pre == 'after' || status_pre == 'finished' ? 'finished' : '']" @click.native="submit">
        {{status_pre == 'edit' || status_pre == 'before' ? '投票' : status_pre == 'after' ?  $t('c.Vote.text6'): status_pre == 'finished' ? $t('c.Vote.text7') : ''}}
      </btn>
      <div v-if="status_pre == 'before'" class="mt16 fs12 black-3 lh1 text-center">{{$t('c.Vote.text8')}}</div>
      <div v-if="status_pre == 'edit'" class="mt16 fs12 black-3 lh1 text-center">{{$t('c.Vote.text9')}}</div>
  </div>
</template>

<script>
import { POST_CAST_VOTE} from "@/api/config";

import {mapState} from 'vuex'

export default {
  name: "vote",
  props: {
    status: {
      // default: "before",
      default: "edit", //before , after , edit,
    },
    vote: {
      default: {}
    },
  },
  computed:{
      ...mapState('app',['browser_size']),
      is_disable(){
        return this.status_pre == 'edit' || this.status_pre == 'after'
      },
      has_my_vote_pre(){
          return this.$is_array(this.my_vote_pre) && this.my_vote_pre.length > 1 || this.my_vote_pre > 0
      },
      post_data(){
          return {
              vote_id:this.vote_pre.vote_id,
              vote:this.vote_pre.chosen_type == 1 ? [this.my_vote_pre] : this.my_vote_pre,
          }
      }
  },
  data() {
    return {
      // list:[{name:'1111',value:1},{name:'2222',value:2},{name:'3333',value:3}],
    //   list:this.vote.options,
    //   my_vote:[],
      status_pre:this.status,
      my_vote_pre:this.vote.my_vote || (this.vote.chosen_type == 2 ? [] : ''),
      vote_pre:this.vote
    };
  },
  mounted() {},
  methods: {
    open_img(src) {
      this.$mixin_show_modal_img(0, [src]);
    },
    edit(){
      let data = {
        vote_id:this.vote_pre.vote_id
      }
      if(this.vote_pre.pic){ //vote 有定制的带图功能
        data.pic = this.vote_pre.pic
      }
      this.$mixin_show_modal_vote(data)
    },
    async del(){
      let re = await this.$mixin_confirm({title: '确认删除该投票设置么'});
      if(re){
          this.$bus.$emit('DEL_VOTE',{vote_id: this.vote_pre.vote_id})
      }
    },
    async submit(){
        if(this.post_data.vote.join('') < 1){
            this.$notify({
                title: '最少选择一项投票',
                // group: 'error',
            })
            return false
        }
        if(this.$http.is_run(POST_CAST_VOTE) || ['edit','after','finished'].indexOf(this.status_pre) != -1){
            return false
        }
        let data = await this.$http.$axios(POST_CAST_VOTE , this.post_data)
        if(data.ec != 200){
            this.$notify({
                title: data.em,
                group: 'error',
            })
            return false
        }

        this.status_pre = 'after'
        // this.my_vote_pre = data.data.my_vote;
        this.vote_pre = data.data.vote;
        this.my_vote_pre = data.data.vote.my_vote;

    },
  },
};
</script>

<style lang="stylus" scoped>
.vm-vote {
  background $white;
  padding:24px;
  border-radius: 4px;
  box-sizing:border-box;
  // .result{
  //   &:last-child{
  //     margin-bottom:16px;
  //   }
  // }
  .progress-bar,
  .progress-box{
    height:4px;
    border-radius: 4px;
    position:relative;
    background:#f0f0f0;
  }
  .progress-bar{
    position:absolute;
    background:$black-1;
    left:0;
    top:0;
    &.on{
      background:$purple;
    }
  }
  .submit{
    width:100%;
    padding:16px;
  }
  .checklist{
      max-height:150px;
      overflow-y:scroll;
  }
  .vm-btn.finished{
      background:transparent;
  }
  .img-pre-box {
    max-height: 100px;
    overflow-y: auto;
    img {
      width: auto;
      max-width: 100%;
      display: block;
      border-radius: 2px;
    }
  }
  &.small{
    background $white-bg;
    padding:16px;
  }
}
</style>
